import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import environment from "../../../../config/environment";
import { MediaSize } from "../../../../types/MediaImage";
import { getMediaImage } from "../../../../utils/images";
import styles from "./styles.module.scss";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "amp-story-player": unknown;
    }
  }
}

export const AMPStoriesPlayer = ({ items, setShowPlayer }) => {
  const playerRef = useRef(null);
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    const scripts = [
      "https://cdn.ampproject.org/v0.js",
      "https://cdn.ampproject.org/v0/amp-story-player-0.1.js",
    ];

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const loadScripts = async () => {
      for (const src of scripts) {
        await loadScript(src);
      }

      setScriptsLoaded(true);
    };

    loadScripts();

    return () => {
      scripts.forEach((src) => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const player = playerRef.current;

    const closePlayer = () =>
      setShowPlayer({
        show: false,
        index: 0,
      });

    if (player) {
      player.addEventListener("amp-story-player-close", closePlayer);
    }

    return () => {
      if (player) {
        player.removeEventListener("amp-story-player-close", closePlayer);
      }
    };
  }, [scriptsLoaded, setShowPlayer]);

  return (
    scriptsLoaded && (
      <div className={styles.containerPlayer}>
        <amp-story-player layout="fill" ref={playerRef}>
          <script
            type="application/json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                controls: [
                  {
                    name: "close",
                    position: "end",
                  },
                  {
                    name: "skip-to-next",
                  },
                ],
              }),
            }}
          />
          {items.map((item, index) => (
            <a key={index} href={environment.wpUrl + item.uri}>
              <Image
                src={getMediaImage(item.featuredImage, MediaSize.LARGE)}
                width="360"
                height="600"
                loading="lazy"
                data-amp-story-player-poster-img
                alt=""
              />
              {item.title}
            </a>
          ))}
        </amp-story-player>
      </div>
    )
  );
};
